// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"0a8d9439","175":"d4da65d5","292":"e8678b05","313":"7b25dd44","878":"5e062353"}[chunkId] + ".chunk.js";
};